"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardActionArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardActionArea = require("./PropertyCardActionArea.styles");
/**
 * A container for action buttons in a `PropertyCard`.
 *
 * @since 8.63.0
 */
var PropertyCardActionArea = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardActionArea.StyledPropertyCardActionArea, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardActionArea = PropertyCardActionArea;
PropertyCardActionArea.displayName = 'PropertyCard.ActionArea';